import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { Operator } from "../models/Operator";

export const getOperators = async ({
	id = null,
}: {
	id?: number | null;
} = {}): Promise<Operator[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}

	const resp = await apiService.callV2("[MILL].[GetOperators]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Operator[];
	}
	throw new Error(resp.message || "Error fetching operators");
};

export const upsertOperator = async (operator: Operator): Promise<Operator> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: operator.Id },
		{ name: "Name", value: operator.Name },
		{ name: "ClockNumber", value: operator.ClockNumber },
		{ name: "Active", value: operator.Active },
	];

	const resp = await apiService.callV2("[MILL].[UpsertOperator]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as Operator;
	}
	throw new Error(resp.message || "Error saving operator");
};

export const removeOperator = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2("[MILL].[RemoveOperator]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting operator");
	}
};
